/**
 * "이름 <email@domain>" 또는 순수 이메일에서 주소만 추출
 */
export function extractEmail(address) {
  if (address == null) return '';
  const value = String(address).trim();
  if (!value) return '';
  const match = value.match(/^(.*)<(.+)>$/);
  if (match) {
    return match[2].trim();
  }
  return value;
}

/**
 * 이메일 오류 사유 반환. 정상이면 null.
 */
export function getEmailError(email) {
  if (email == null || typeof email !== 'string' || !email.trim()) {
    return '메일 주소가 비어 있습니다';
  }
  // 앞뒤 trim 하지 않음 — 중간 공백도 오류로 안내해야 함
  if (/\s/.test(email)) {
    return '공백이 포함되어 있습니다';
  }
  if (!email.includes('@')) {
    return '@가 없습니다';
  }
  if ((email.match(/@/g) || []).length > 1) {
    return '@가 두 개 이상입니다';
  }
  const at = email.indexOf('@');
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  if (!local || !domain) {
    return '@ 앞 또는 뒤가 비어 있습니다';
  }
  if (!domain.includes('.')) {
    return '도메인 형식이 올바르지 않습니다';
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return '형식이 올바르지 않습니다';
  }
  return null;
}

/**
 * 공백·기본 형식 오류를 걸러내는 이메일 검사 (발송 전 UI용)
 */
export function isValidEmail(email) {
  return getEmailError(email) === null;
}

/**
 * 받는사람/참조 목록에서 잘못된 주소를 찾아 반환
 * @param {Array<{name?: string}|string>} recipients
 * @returns {{ email: string, reason: string }[]}
 */
export function findInvalidEmails(recipients) {
  if (!recipients || !Array.isArray(recipients)) return [];
  const invalid = [];
  for (const item of recipients) {
    const raw = typeof item === 'string' ? item : item?.name;
    const email = extractEmail(raw);
    const reason = getEmailError(email);
    if (reason) {
      invalid.push({
        email: email || String(raw || '').trim() || '(빈 주소)',
        reason,
      });
    }
  }
  return invalid;
}

/**
 * 안내 메시지용 한 줄 목록
 * @param {{ email: string, reason: string }[]} invalidEmails
 * @returns {string[]}
 */
export function formatInvalidEmailLines(invalidEmails) {
  if (!invalidEmails?.length) return [];
  return invalidEmails.map(({ email, reason }) => `${email} — ${reason}`);
}
